import { SVGProps } from 'react';
import SVG from '.';
import { SVGIconFilterGrid } from './SVGIconFilterGrid';
import { SVGIconFilterVector } from './SVGIconFilterVector';
import SVGIconFilterAlphabetical from './SVGIconFilterAlphabetical';
import SVGIconFilterPrice from './SVGIconFilterPrice';
import { SVGIconFilterBar } from './SVGIconFilterBar';

interface SVGIconFilterProps extends SVGProps<any> {
  borderOnly?: boolean;
}

export default Object.assign(
  ({
    children,
    width = 20,
    height = 20,
    color = '#364856',
    borderOnly = false,
    ...rest
  }: SVGIconFilterProps) => {
    return (
      <SVG
        className="svg-icon-filter"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 1792 1792`}
        {...rest}
      >
        <path
          {...(() =>
            borderOnly
              ? {
                  fill: 'transparent',
                  stroke: color,
                  strokeWidth: '130',
                }
              : {
                  fill: color,
                })()}
          d="M1595 295q17 41-14 70l-493 493v742q0 42-39 59-13 5-25 5-27 0-45-19l-256-256q-19-19-19-45v-486l-493-493q-31-29-14-70 17-39 59-39h1280q42 0 59 39z"
        />
      </SVG>
    );
  },
  {
    Grid: SVGIconFilterGrid,
    Vector: SVGIconFilterVector,
    Alphabetical: SVGIconFilterAlphabetical,
    Price: SVGIconFilterPrice,
    Bar: SVGIconFilterBar,
  },
);
